import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import {
    ReimbursementSpreadSheetFormProps
} from "../../../pages/reimbursements/components/spreadsheet/ReimbursementSpreadSheetForm";
import ReimbursementLineItemsForm from "../../../pages/reimbursements/components/claims/ReimbursementLineItemsForm";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, ReimbursementSpreadSheetFormProps {}

type Props = OwnProps;

// @ts-ignore
const ReimbursementClaimLineItemModal = NiceModal.create<Props>(({onClose, header,...rest}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <ReimbursementLineItemsForm {...rest}/>
        </SlideOver>
    )
})

export default ReimbursementClaimLineItemModal;
